import React from 'react';
import { SVGProps } from 'react';
import { clsx } from 'clsx';
import { IconProps, iconVariants } from '../icon';
import '../icon/icon.module.scss';
type Props = IconProps & Omit<SVGProps<SVGSVGElement>, keyof IconProps>;
const Cross = React.forwardRef<SVGSVGElement, Props>(({ color, size, opacity = 1, className, ...props }, ref) => {
  const classes = clsx(
    iconVariants({
      color,
      size,
    }),
    className,
  );
  const style: React.CSSProperties = {
    '--opacity': opacity,
  };
  return React.cloneElement(
    <svg xmlns="http://www.w3.org/2000/svg" width={13} height={13} fill="none" viewBox="0 0 13 13" ref={ref} {...props}>
      <path fill="currentColor" d="M1.638.33 12.75 11.48l-1.265 1.27L.373 1.6z" />
      <path fill="currentColor" d="M.25 11.379 11.34.25l1.265 1.27-11.09 11.128z" />
    </svg>,
    {
      role: 'presentation',
      focusable: false,
      className: classes,
      'aria-hidden': true,
      style,
      ...props,
    },
  );
});
Cross.displayName = 'Cross';
export default Cross;
